// import React, { useEffect, useState, useImperativeHandle, useContext } from "react";
// import { Container, Col, Row } from "react-bootstrap";
// import { useNavigate } from "react-router-dom";
// import ReadMore from "./../../CommonUI/ReadMoreBtn/ReadMore";
// import Slider from "react-slick";
// import CompanyLogo from "./../../../Images/comlogo.png";
// import URLstateContext from "../../../provider/CommonContext";
// import "./SimilerEquities.css";
// import { useLocalStorage } from "../../utils/useLocalStorage";
// function SimilerEquities(props, ref) {
//   const [data, setData] = useState(false);
//   const [dataExchange, setExchangeData] = useState("NSE");

//   const { BaseURL } = useContext(URLstateContext);

//   const [text, setText] = useState("More");
//   let getExchange = props.exchange;
//   console.log("getExchange sim"+getExchange);
//   let getCoCode = props.coCode;
//   let navigate = useNavigate();
//   let actualData;
//   let findExchange;
//   const [cocode, setcocode] = useLocalStorage("cocode", "");

//   useEffect(() => {
//     const getUrlchart = BaseURL + "Peer-Comparison/";
//     if (props.coCode != "" && props.exchange != "") {
//       fetch(`${getUrlchart}/${getCoCode}/${getExchange}/20`)
//        .then((response) => response.json())
//        .then((data) => {
//           actualData = data.data;
//           setData(actualData);
//         })
//        .catch((error) => {
//           //console.log("not found the api");
//         });
//     }
//   }, []);

//   useEffect(() => {
//     const getUrlchart = BaseURL + "Peer-Comparison/";
//     //console.log("url:"+getUrlchart);
//     if (props.coCode != "" && props.exchange != "") {
//       fetch(`${getUrlchart}/${getCoCode}/${getExchange} /20`)
//         .then((response) => response.json())
//         .then((data) => {
//           actualData = data.data;
//           //console.log("actualData:"+JSON.stringify(actualData));
//           setData(actualData);
//         })
//         .catch((error) => {
//           //console.log("not found the api");
//         });
//     }
//     let widthWindow = window.matchMedia("(max-width: 450px)")
//     if (widthWindow.matches) {
//       setTimeout(() => {
//         let sliderBtn = document.getElementsByClassName('slick-next');
//         sliderBtn[1].click();
//       }, 2000)
//     }

//   }, [props.exchange, props.coCode]);



  
//   const knowMoreBtn = (event) => {
//     const compcocode = event.currentTarget.dataset.id;
//     //alert("compcode:" + compcocode);
//     const compcode_array = compcocode.split('-');
//     const getCoCodeId = compcode_array[0].replace(/ /g, '-').replace('&', 'and').replace('+', '').replace(/\./g, '');
//     var data = { "compcode": compcode_array[1], "compname": compcode_array[0] };
//     setcocode(compcode_array[1]);
//     const getDExchange = dataExchange;
//     window.open("/stocks/" + getCoCodeId.toLowerCase(), "_blank");
//     //navigate("/stocks/" + getCoCodeId, {
//     //state: { id: `${getDExchange}`, coCode: `${getCoCodeId}` },
//     //});
//   };

//   useImperativeHandle(ref, () => ({
//     chnageexchnagesimilarstocks: (excgh) => {
//       const getUrlchart = BaseURL + "Peer-Comparison/";
//       fetch(`${getUrlchart}/${getCoCode}/${excgh}/20`)
//         .then((response) => response.json())
//         .then((data) => {
//           actualData = data.data;
//           setData(actualData);
//         })
//         .catch((error) => {
//         });
//     }
//   }));


//   const settings = {
//     dots: true,
//     infinite: false,
//     speed: 500,
//     slidesToShow: 2,
//     slidesToScroll: 2,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 1,
//           infinite: false,
//           dots: true,
//         }
//       },
//       {
//         breakpoint: 767,

//         settings: {
//           dots: true,
//           infinite: false,
//           speed: 500,
//           arrows: true,
//           slidesToShow: 1,
//           slidesToScroll: 1,
//         },
//       },
//       {
//         breakpoint: 575,
//         settings: {
//           dots: true,
//           infinite: false,
//           speed: 500,
//           arrows: true,
//           slidesToShow: 1,
//           slidesToScroll: 1,
//         },
//       },
//     ],
//   };


//   return (
//     <>
//       <section className="similar-equities-block">
//         <Container className="table-boxSimilarE">
//           <Row>
//             <Col lg={12} md={12} sm={12} className="EquPadding">
//               <h3>Similar Equities</h3>
//               {(data === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''}

//               <Slider {...settings} id="demo">
//                 {data &&
//                   data.map(
//                     ({ id, co_code, companyname, price, pricediff, percentchange }) => (
//                       <div key={co_code} className="each-equity">
//                         <div className="each-equity-inner">
//                           <div className="each-equity-alpha">
//                             <img src={CompanyLogo} alt="CompanyLogo-img" />
//                           </div>
//                           <div className="each-equity-beta">
//                             <div className="">
//                               <h4>{companyname}</h4>
//                             </div>
//                             <h6>Share Price</h6>
//                             <p>
//                               &#8377; {price}
//                               <span
//                                 className={
//                                   pricediff.toFixed(2) > 0
//                                     ? "textGreen"
//                                     : "textRed"
//                                 }
//                               >
//                                 {pricediff.toFixed(2)}
//                               </span>
//                               <span
//                                 className={
//                                   percentchange.toFixed(2) > 0
//                                     ? "textGreen"
//                                     : "textRed"
//                                 }
//                               >
//                                 {"(" + percentchange.toFixed(2) + "%)"}
//                               </span>
//                             </p>
//                             <h6
//                               onClick={knowMoreBtn}
//                               data-id={companyname + '-' + co_code}
//                               id={dataExchange}
//                             >
//                               {/* <span>Read {text}</span>  */}
//                               <ReadMore name="Know" />
//                             </h6>
//                           </div>
//                         </div>
//                       </div>
//                     )
//                   )}
//               </Slider>
//             </Col>
//           </Row>
//         </Container>
//       </section>
//     </>

//   );


// }
// export default React.forwardRef(SimilerEquities);

import React, { useEffect, useState, useImperativeHandle, useContext } from "react";
import { Container, Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import ReadMore from "./../../CommonUI/ReadMoreBtn/ReadMore";
import Slider from "react-slick";
import CompanyLogo from "./../../../Images/comlogo.png";
import URLstateContext from "../../../provider/CommonContext";
import "./SimilerEquities.css";
import { useLocalStorage } from "../../utils/useLocalStorage";

function SimilerEquities(props, ref) {
  const [data, setData] = useState(false);
  const [dataExchange, setExchangeData] = useState("NSE");

  const { BaseURL } = useContext(URLstateContext);

  const [text, setText] = useState("More");
  let getExchange = props.exchange || "NSE"; // Set default exchange to NSE if not provided
  console.log("getExchange sim" + getExchange);
  let getCoCode = props.coCode;
  let navigate = useNavigate();
  let actualData;
  let findExchange;
  const [cocode, setcocode] = useLocalStorage("cocode", "");

  useEffect(() => {
    const getUrlchart = BaseURL + "Peer-Comparison/";
    if (getCoCode!= "") {
      fetch(`${getUrlchart}/${getCoCode}/${getExchange}/20`)
       .then((response) => response.json())
       .then((data) => {
          actualData = data.data;
          setData(actualData);
        })
       .catch((error) => {
          //console.log("not found the api");
        });
    }
  }, []);

  useEffect(() => {
    const getUrlchart = BaseURL + "Peer-Comparison/";
    if (getCoCode!= "" && getExchange!= "") {
      fetch(`${getUrlchart}/${getCoCode}/${getExchange}/20`)
       .then((response) => response.json())
       .then((data) => {
          actualData = data.data;
          setData(actualData);
        })
       .catch((error) => {
          //console.log("not found the api");
        });
    }
    let widthWindow = window.matchMedia("(max-width: 450px)")
    if (widthWindow.matches) {
      setTimeout(() => {
        let sliderBtn = document.getElementsByClassName('slick-next');
        sliderBtn[1].click();
      }, 2000)
    }

  }, [getExchange, getCoCode]);

  const knowMoreBtn = (event) => {
    const compcocode = event.currentTarget.dataset.id;
    //alert("compcode:" + compcocode);
    const compcode_array = compcocode.split('-');
    const getCoCodeId = compcode_array[0].replace(/ /g, '-').replace('&', 'and').replace('+', '').replace(/\./g, '');
    var data = { "compcode": compcode_array[1], "compname": compcode_array[0] };
    setcocode(compcode_array[1]);
    const getDExchange = dataExchange;
    window.open("/stocks/" + getCoCodeId.toLowerCase(), "_blank");
    //navigate("/stocks/" + getCoCodeId, {
    //state: { id: `${getDExchange}`, coCode: `${getCoCodeId}` },
    //});
  };

  useImperativeHandle(ref, () => ({
    chnageexchnagesimilarstocks: (excgh) => {
      const getUrlchart = BaseURL + "Peer-Comparison/";
      fetch(`${getUrlchart}/${getCoCode}/${excgh}/20`)
       .then((response) => response.json())
       .then((data) => {
          actualData = data.data;
          setData(actualData);
        })
       .catch((error) => {
        });
    }
  }));

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
        }
      },
      {
        breakpoint: 767,

        settings: {
          dots: true,
          infinite: false,
          speed: 500,
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 575,
        settings: {
          dots: true,
          infinite: false,
          speed: 500,
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };


  return (
    <>
      <section className="similar-equities-block">
        <Container className="table-boxSimilarE">
          <Row>
            <Col lg={12} md={12} sm={12} className="EquPadding">
              <h3>Similar Equities</h3>
              {(data === null)? <h5 className="errormsgComNew">No Data Available!!!</h5> : ''}

              <Slider {...settings} id="demo">
                {data &&
                  data.map(
                    ({ id, co_code, companyname, price, pricediff, percentchange }) => (
                      <div key={co_code} className="each-equity">
                        <div className="each-equity-inner">
                          <div className="each-equity-alpha">
                            <img src={CompanyLogo} alt="CompanyLogo-img" />
                          </div>
                          <div className="each-equity-beta">
                            <div className="">
                              <h4>{companyname}</h4>
                            </div>
                            <h6>Share Price</h6>
                            <p>
                              &#8377; {price}
                              <span
                                className={
                                  pricediff.toFixed(2) > 0
                                   ? "textGreen"
                                    : "textRed"
                                }
                              >
                                {pricediff.toFixed(2)}
                              </span>
                              <span
                                className={
                                  percentchange.toFixed(2) > 0
                                   ? "textGreen"
                                    : "textRed"
                                }
                              >
                                {"(" + percentchange.toFixed(2) + "%)"}
                              </span>
                            </p>
                            <h6
                              onClick={knowMoreBtn}
                              data-id={companyname + '-' + co_code}
                              id={dataExchange}
                            >
                              {/* <span>Read {text}</span>  */}
                              <ReadMore name="Know" />
                            </h6>
                          </div>
                        </div>
                      </div>
                    )
                  )}
              </Slider>
            </Col>
          </Row>
        </Container>
      </section>
    </>

  );


}
export default React.forwardRef(SimilerEquities);
